import { Component, OnInit, OnDestroy, Input, Optional, SkipSelf } from "@angular/core";
import { ControlContainer, FormControl, FormGroup } from "@angular/forms";
import { COMMON_IMPORTS } from "../../global-misc/common-imports";
import { DropdownModule, DropdownChangeEvent } from "primeng/dropdown";
import { CountryModel } from "../../global-data-models/country.model";
import { GlobalPhoneInputFacade, PhoneInputState } from "./global-phone-input.facade";
import { Subject, takeUntil } from "rxjs";

@Component({
    standalone: true,
    selector: "app-global-phone-input",
    imports: [...COMMON_IMPORTS, DropdownModule],
    templateUrl: "./global-phone-input.component.html",
    providers: []
})
export class GlobalPhoneInputComponent implements OnInit, OnDestroy {
    @Input() placeholder = "Enter phone number";
    @Input() phoneCodeControlName = 'telephone_code';
    @Input() phoneNumberControlName = 'telephone';
    @Input() formGroup!: FormGroup;

    public countries: CountryModel[] = [];
    public inputId = `global-phone-input-${Math.random().toString(36).substr(2, 9)}`;
    public currentPhoneCodeCountry?: CountryModel;

    private destroy$ = new Subject<void>();

    constructor(
        private readonly facade: GlobalPhoneInputFacade,
    ) { }

    async ngOnInit() {
        this.facade.state$
            .pipe(takeUntil(this.destroy$))
            .subscribe((state: PhoneInputState) => {
                this.countries = state.countries;
            });

        await this.facade.loadCountries();

        this.currentPhoneCodeCountry = this.getCountryFromPhoneCode();
        console.log("currentPhoneCodeCountry = ", this.currentPhoneCodeCountry);
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    public getCountryFromPhoneCode(): CountryModel | undefined {
        const phoneCodeControl: FormControl = this.getFormControl(this.phoneCodeControlName)!;
        if (!phoneCodeControl) {
            console.log("no phone code control yet");
            return undefined;
        }

        console.log("phone code control value = ", phoneCodeControl.value);

        return this.countries.filter(country => country.phoneCode === phoneCodeControl.value)[0];
    }

    public getSelectedCountry(): CountryModel | undefined {
        const phoneCodeControl = this.getFormControl(this.phoneCodeControlName);
        if (!phoneCodeControl || !phoneCodeControl.value) {
            return undefined;
        }
        return this.countries.find(country => country.phoneCode === phoneCodeControl.value);
    }

    public getFormControl(name: string): FormControl | null {
        if (!this.formGroup) {
            return null;
        }
        return this.formGroup.get(name) as FormControl || null;
    }

    public hasFormControl(name: string): boolean {
        return this.formGroup && this.formGroup.get(name) !== null;
    } onCountryChange(event: DropdownChangeEvent): void {
        const phoneCodeControl = this.formGroup?.get(this.phoneCodeControlName);
        if (phoneCodeControl) {
            // event.value contains the phoneCode string since we use optionValue="phoneCode"
            phoneCodeControl.setValue(event.value);
            this.emitNormalizedPhone();
        }
    }

    onPhoneNumberChange(event: Event): void {
        const target = event.target as HTMLInputElement;
        const phoneNumberControl = this.formGroup?.get(this.phoneNumberControlName);
        if (phoneNumberControl) {
            phoneNumberControl.setValue(target.value);
            this.emitNormalizedPhone();
        }
    }

    onBlur(): void {
        // Optionally handle blur
    }

    private emitNormalizedPhone(): void {
        if (!this.formGroup) {
            return;
        }

        const code = this.formGroup.get(this.phoneCodeControlName)?.value;
        let number = this.formGroup.get(this.phoneNumberControlName)?.value || '';
        let normalized = number.trim();
        while (normalized.startsWith('0') && normalized.length > 1) {
            normalized = normalized.substring(1);
        }
        // Optionally emit or use normalized value as needed
    }
}